module.exports = __webpack_public_path__ + "96CDE27BE6A761F15653E5A1B5B5BF91better3.6cfef433.png";